const Title = ({ children, size = 'text-xl lg:text-6xl' }) => {
    return (
        <h2 className={`uppercase ${size} nobblee-bold`}>
            {children}
        </h2>
    );
};

export default Title;
